import React, { useState, useRef, useEffect } from 'react'
import { message } from 'antd'
import Icon from 'meinian-package/src/component/icon'
import { BatchStart, BatchAll, BatchNum, BatchStop, BatchOptions } from 'component'
import MNWaterfallApi from 'component/waterfall/masonryApi'
import Marking from 'image/workbench/marking.png'
import { request, message as mes } from 'meinian-package/src/utils'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import Upload from 'meinian-package/src/component/upload/image'
import Button from 'meinian-package/src/baseComponent/button'
import MarkingCard from 'component/waterfall.card/marking'
import RecordInfoCard from 'component/waterfall.card/marking/recordInfoCard'
import getBoxLabelRetList from 'common/getBoxLabelRetList'
import emptyJson from './emptyData.json'
import CustomizeHeader, { CustomizeHeaderLeftDefault } from '../../components/header/customizeHeader'
import FeedbackModal from '../../components/feedbackModal'
import InfoModal from '../../components/feedbackModal/infoModal'
import styles from './index.module.less'

export default () => {
  const [isBatch, setIsBatch] = useState(false)
  const [batchAll, setBatchAll] = useState([])
  const waterfallRef = useRef()
  const [limit, setLimit] = useState({
    limit: 0,
    todayCount: 0,
  })

  const afterUpload = (file) => {
    const images = []
    file.forEach((item) => {
      images.push({ picUrl: item.url, source: 1 })
    })
    if (!images.length) {
      return
    }
    request.post('/zhikuan/intelligence-tag/recognize', { images }).then((success) => {
      if (success) {
        message.success('上传图片成功')
        waterfallRef.current?.init()
      }
    })
  }

  const onDeleteAll = (val) => {
    ModalConfirm.show({
      title: '确认删除',
      content: '是否删除当前识别记录？',
      onOk: async () => {
        request.post('/zhikuan/intelligence-tag/delete', { unionIdList: [...val] }).then(success => {
          if (success) {
            message.success('删除成功')
            setIsBatch(false)
            waterfallRef.current?.init()
          }
        })
      },
    })
  }

  const fetchData = () => {
    request.get('/zhikuan/intelligence-tag/limit').then((res) => {
      setLimit(res)
    })
  }
  const [alertVisible, setAlertVisible] = useState(+localStorage.getItem('mn-marking-header-content-visible'))
  useEffect(() => {
    if (!localStorage.getItem('mn-marking-header-content-visible')) {
      localStorage.setItem('mn-marking-header-content-visible', '1')
      setAlertVisible(1)
    }
  }, [])
  const onClose = () => {
    localStorage.setItem('mn-marking-header-content-visible', '0')
    setAlertVisible(0)
  }

  const [feedbackModalVisible, setFeedbackModalVisible] = useState(false)
  const [infoModalVisible, setInfoModalVisible] = useState(false)
  const [feedbackModalData, setFeedbackModalData] = useState({})
  const infoModalRef = useRef(null)

  useEffect(() => {
    const subUploadImage = () => {
      waterfallRef.current?.init()
    }
    mes.sub('onMNUploadImage', subUploadImage)
    return () => {
      mes.remove('onMNUploadImage', subUploadImage)
    }
  }, [])

  const onFeedback = (_data) => {
    setFeedbackModalData(_data)
    setFeedbackModalVisible(true)
  }
  const onFeedbackModalOk = async (params) => {
    request.post('/zhikuan/intelligence-tag/feedback', params).then(success => {
      if (success) {
        setFeedbackModalVisible(false)
        setInfoModalVisible(true)
        setTimeout(() => {
          infoModalRef.current?.onOk()
        })
        return true
      }
    })
    return false
  }
  return <div>
    <CustomizeHeader
      hiddenSearch
      renderLeft={() => <CustomizeHeaderLeftDefault
        paths={[{
          name: '工作台',
          path: '/home/workbench/index'
        }, {
          name: '智能打标',
          path: null,
        }]}
      />}
    />
    <div className={styles['mn-marking']}>
      <div className="mn-marking-header">
        <Upload onSuccess={afterUpload} multiple maxCount={20} maxSize={10}>
          <Button type="primary" className="mn-marking-upload-image-btn">
            <Icon type="m-shangchuan" className="mn-marking-upload-image-btn-icon" />
            <span style={{ marginLeft: '8px' }}>上传图片</span>
          </Button>
        </Upload>
      </div>
      {
      !!alertVisible && <div className="mn-marking-header-content">
        <div className="mn-marking-header-content-left">
          <div className="mn-marking-header-content-left-line-1">智能打标</div>
          <div className="mn-marking-header-content-left-line-2">上传服饰图片，系统自动识别服饰的品类、颜色、风格、工艺等信息，支持批量上传图片识别</div>
          <Upload onSuccess={afterUpload} multiple maxCount={20} maxSize={10}>
            <div className="mn-marking-header-content-left-line-3">
              上传图片 <Icon type="m-Vxing_you" />
            </div>
          </Upload>
        </div>
        <div className="mn-marking-header-content-right">
          <img src={Marking} />
        </div>
        <div className="mn-marking-header-content-close" onClick={onClose}><Icon type="m-guanbi_tianchong" /></div>
      </div>
    }
      <div className="mn-marking-list">
        <div style={{ paddingBottom: '16px' }}>
          <div className="mn-marking-list-header">
            <div className="mn-marking-list-header-title">识别记录</div>
            <div className="mn-marking-list-header-title-right">
              {!!batchAll.length && !isBatch && <BatchStart onClick={() => setIsBatch(true)} />}
              <div style={{ marginLeft: '16px' }}>今天识别额度<span>{limit.todayCount}/{limit.limit === -1 ? '不限' : limit.limit}</span></div>
            </div>
          </div>
          {
        isBatch && <div className="batch-operation">
          <div className="meinian-space" />
          <BatchAll style={{ marginRight: 16 }} keyValues={batchAll?.map(i => i.unionId)} infos={batchAll} />
          <BatchNum style={{ marginRight: 40 }} />
          <BatchOptions.DeleteItem onChange={onDeleteAll} />
          <BatchStop onClick={() => setIsBatch(false)} />
        </div>
      }
        </div>
        <div className="mn-marking-list-content-wrapper">
          <MNWaterfallApi
            idKey={['imageGroupEntityId', 'inspirationId']}
            renderItem={MarkingCard}
            ref={waterfallRef}
            gutter={24}
            cardProps={{ isBatch, onFeedback, infoHeight: 50 }}
            url="/zhikuan/intelligence-tag/images"
            method="post"
            params={{}}
            afterLoad={data => {
              setBatchAll(data)
              fetchData()
            }}
            empty={<EmptyList />}
            emptySubTitle="你有审核权限的灵感集中提交审核的款式都将展示在此处"
            emptyType="image"
          />
        </div>
        {feedbackModalVisible && <FeedbackModal
          visible={feedbackModalVisible}
          picUrl={feedbackModalData.mainUrl}
          unionId={feedbackModalData.unionId}
          boxLabelRetList={feedbackModalData.boxLabelRetList}
          onOk={onFeedbackModalOk}
          onClose={() => { setFeedbackModalVisible(false) }}
        />}
        {
      infoModalVisible && <InfoModals
        infoModalRef={infoModalRef}
        visible={infoModalVisible}
        onClose={() => {
          setInfoModalVisible(false)
        }}
      />
    }
      </div>
    </div>
  </div>
}

const InfoModals = ({ infoModalRef, ...props }) => {
  return <InfoModal
    ref={infoModalRef}
    {...props}
  />
}

const EmptyList = () => {
  const result = getBoxLabelRetList(emptyJson.boxLabelRetList)
  return <div className="mn-marking-list-empty">
    <div className="empty-content">
      <img src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/ins-selected/1666322620004_cmg6fj17gm.png" />
      <div>
        <RecordInfoCard className="empty-show" boxLabelRetList={result} />
      </div>
    </div>
  </div>
}
